import Style from './index.module.css';
import { IcebergAlert, IcebergAlertVariant, IcebergIcon } from '@tradesolution/iceberg-ui-react';
import { Toast } from '../../utils/contexts/ToastProvider/types';

interface Props {
  toasts: Toast[];
  handleCloseToast: (index: number) => void;
}

const getVariant = (type: string): IcebergAlertVariant => {
  switch (type) {
    case 'success':
      return IcebergAlertVariant.Success;
    case 'danger':
    case 'error':
      return IcebergAlertVariant.Danger;
    case 'warning':
      return IcebergAlertVariant.Warning;
    case 'info':
    default:
      return IcebergAlertVariant.Primary;
  }
};

const Toaster = (props: Props) => {
  return (
    <div className={Style.toastContainer}>
      {props.toasts &&
        props.toasts.map((t, index) => {
          return (
            <div key={t.id ?? `toast-${index}`} className={Style.toastItem}>
              <IcebergAlert variant={getVariant(t.type)} body={t.message} />
              {t.dismissible && (
                <button
                  className={Style.closeButton}
                  onClick={() => props.handleCloseToast(index)}
                  aria-label="Lukk"
                >
                  <IcebergIcon icon="close" />
                </button>
              )}
            </div>
          );
        })}
    </div>
  );
};
export default Toaster;
